import {timestampFromIsoDate} from '@cypro/engine/utils'
import {getShortDateFormatter} from '@cypro/ui/utils'

export function formatIsoDate(isoDate: string): string {
  return getShortDateFormatter().format(timestampFromIsoDate(isoDate))
}

// Calendar dates are stored as UTC midnight (see `timestampFromIsoDate`). This returns the current user's local calendar day on that same timeline, so a therapy dated "today" is not pushed to yesterday by a west-of-UTC offset.
export function startOfTodayUtc(): number {
  const now = new Date()
  return Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
}
